import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavContentComponent } from './sidenav-content.component';
import { MaterialModuleMobi } from '../material/material.module';
import { MobiThemeModule } from '../mobi-theme/mobi-theme.module';
import { MobiPagesModule } from '../mobi-pages/mobi-pages.module';
import { MobilesettingsModule } from '../mobilesettings/mobilesettings.module';
import { SidenavContentListModule } from '../sidenav-content-list/sidenav-content-list.module';
import { PublishAppModule } from '../publish-app/publish-app.module';
import { EntityModule } from '../entity/entity.module';
import { MobileAnalyticsModule } from '../mobile-analytics/mobile-analytics.module';
import { EntitySubmissionDetailsModule } from '../entity-submission-details/entity-submission-details.module';
import { ApiCallsModule } from 'shared-library';

@NgModule({
  declarations: [
    SidenavContentComponent,
  ],
  imports: [
    CommonModule,
    MaterialModuleMobi,
    MobiThemeModule,
    MobiPagesModule,
    MobilesettingsModule,
    SidenavContentListModule,
    PublishAppModule,
    EntityModule,
    MobileAnalyticsModule,
    EntitySubmissionDetailsModule,
    ApiCallsModule
  ],
  exports:[
    SidenavContentComponent
  ]
})
export class SidenavContentModule { }
